<template>
  <div class="ai-greeting">
    <MarkdownItVue :content="content" @render-complete="$emit('completed')" ></MarkdownItVue>
  </div>
</template>

<script>
import MarkdownItVue from 'markdown-it-vue';

export default {
  components: { MarkdownItVue },
  props: {
    msgInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    content() {
      const { content = '' } = this.msgInfo;
      return content.replace(/(\\n|\\r|\\r\\n)/g, '\n');
    },
  },

};
</script>

<style lang="less">
.ai-greeting {
    width: 100%;
    padding: 18px;
    background-color: rgba(0, 0, 0, 0.3);
    color: rgba(255, 255, 255, 1);
    font-style: 14px;
    line-height: 18px;
    font-family: Roboto;
    border-radius: 12px;
    // filter: blur(6px);
    backdrop-filter: blur(6px);
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

</style>
